export const TripCategoriesConfig: any = {};
